export default "__VITE_ASSET__dDghkNqK__"